// FileContext.tsx
import React, { createContext, useState, ReactNode } from 'react';

interface FileContextType {
    file: File | null;
    setFile: (file: File | null) => void;
}

export const FileContext = createContext<FileContextType | undefined>(undefined);

interface FileProviderProps {
    children: ReactNode;
}

export const FileProvider: React.FC<FileProviderProps> = ({ children }) => {
    const [file, setFile] = useState<File | null>(null);

    return (
        <FileContext.Provider value={{ file, setFile }}>
            {children}
        </FileContext.Provider>
    );
};